module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Light.45f364df.woff2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Light.woff2
// module id = 2350
// module chunks = 50